import {createContext, useContext} from 'react';

export const initialValues = {
  title: "",
  description: "",
  featuresExcluded: [],
  featuresIncluded: [],
  useIncluded: false,
  filtersExcluded: [],
  searchText: "",
  productCartTitle: "",
  productCartDescription: "",
  uploadedImageUrl: "",
  customImageUrl: "",
  notRequired: false,
  selectedFabricators: [],
  mode: "target",
  multipleAddToCart: false,
  isCenterIslandGroup: false,
  hideInCartAndReceipt: true,
  skipProductInfo: false,
  hidePriceNoCart: false,
  skipLockDontApply: false,
  dontMatchFeaturesBySku: false,
  matchAllDisabled: false,
  wizardGroupIcon: "",
  leadStep: "",
  inputFields: [], // objects array
  headerTitle: "",
  headerSubTitle: "",
  viewType: 3,
  visibleInVisualizers: [],
};
export const initialValuesToUpdate = Object.assign({}, initialValues, {
  featuresExcluded: [],
  featuresIncluded: [],
  filtersExcluded: [],
  selectedFabricators: [],
});

export const wizardPopupAction = "CHANGE_WIZARD_POPUP_STATE";

const WizardPopupContext = createContext({});

export const useCustomContext = () => {
  return useContext(WizardPopupContext);
}

export const wizardPopupContextReducer = (state = initialValues, action) => {
  switch (action.type) {
    case wizardPopupAction:
      return {...state, ...action.payload};
    default:
      return state
  }
}

export default WizardPopupContext;
